import "./BotCollectUserFormData.css";

const BotCollectUserFormData = () => {
  return (
    <div className="docs-user-form-container">
      <h1 className="docs-user-form-title">Collect User Form Data</h1>

      <p className="docs-user-form-description">
        Choose what data to collect from your users before they start chatting with your bot. This helps personalize the experience and gather important information upfront.
      </p>

      <h2 className="docs-user-form-subtitle">User Form Settings</h2>

      <p className="docs-user-form-text">
        <strong>Enable User Form:</strong> Toggle to enable or disable the user form that appears before the chat begins.
      </p>

      <p className="docs-user-form-text">
        <strong>Enable Captcha:</strong> Protect your chatbot from automated spam and fraudulent activities by enabling CAPTCHA verification.
      </p>

      <h2 className="docs-user-form-subtitle">Form Management</h2>

      <ul className="docs-user-form-actions">
        <li><strong>Add Question:</strong> Add custom questions to collect specific data from your users.</li>
        <li><strong>Discard Changes:</strong> Revert any unsaved changes made to the user form.</li>
        <li><strong>Save Changes:</strong> Save and apply all modifications to your user form.</li>
      </ul>
    </div>
  );
};

export default BotCollectUserFormData;
